import "babel-polyfill";
import log from 'loglevel';

import Auth from './core/Auth';

import Session from './core/Session';
import MessageBusService from './core/MessageBusService';
import QueryCursor from './core/QueryCursor';
import QueryService from './core/QueryService';
import QueryBrowser from './core/QueryBrowser';
import AsyncEvent from './core/AsyncEvent';
import * as Utility from './core/Utility';
import Validate from './core/Validate';
import Translate from './core/Translate';
import HostNavigatorService from './core/HostNavigatorService';
import AppService from './core/AppService';

import Preset from './dashboard/Preset.js';
import Store from './data/Store.js';
import PresetService from './dashboard/PresetService.js';


import QueryStatusComponent from './ui/QueryStatusComponent.jsx';
import InstantEditValidateBox from './ui/InstantEditValidateBox.jsx';
import ParserSelectorTable from './ui/ParserSelectorTable.jsx';

/* dashboard */

import DashboardWidget from './dashboard/DashboardWidget';
import WidgetProperty from './dashboard/WidgetProperty';

/* Reactree */
import Reactree from './ui/Reactree';

log.setDefaultLevel('info');
log.setLevel('info');

var __extends = (this && this.__extends) || function (d, b) {
	for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	function __() { this.constructor = d; }
	d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var hostNavigator = new HostNavigatorService();
var appService = new AppService();

var Araqne = {
	Auth: Auth,
	Session: Session,
	MessageBusService: MessageBusService,
	QueryCursor: QueryCursor,
	QueryService: QueryService,
	QueryBrowser: QueryBrowser,
	AsyncEvent: AsyncEvent,
	Utility: Utility,
	Validate: Validate,
	Translate: Translate,
	HostNavigatorService: hostNavigator,
	AppService: appService, 
	Dashboard: {
		Preset,
		PresetService
	},
	Data: {
		Store
	},
	Core: {
		QueryService
	}
};

if(typeof window !== 'undefined') {
	// browser
	window.Araqne = Araqne;

	if(typeof window.WebConsole === 'undefined') {
		window.WebConsole = {};
	}
	if(typeof window.WebConsole.Dashboard === 'undefined') {
		WebConsole.Dashboard = {};
	}
	if(typeof window.WebConsole.UI === 'undefined') {
		WebConsole.UI = {};
	}
	WebConsole.Dashboard.DashboardWidget = DashboardWidget;
	WebConsole.Dashboard.WidgetProperty = WidgetProperty;
	WebConsole.Dashboard.__extends = __extends;

	WebConsole.UI.QueryStatusComponent = QueryStatusComponent;
	WebConsole.UI.InstantEditValidateBox = InstantEditValidateBox;
	WebConsole.UI.ParserSelectorTable = ParserSelectorTable;
	WebConsole.UI.Reactree = Reactree;

}
else {
	// node.js
	global.Araqne = Araqne;
}

export { Araqne };



// WEBPACK FOOTER //
// ./resources/WEB-INF/src/Araqne.js